import type { ReactNode } from 'react';
import {
  DefaultTheme as DefaultThemeStyledComponents,
  ThemeProvider as SCThemeProvider,
} from 'styled-components';
import { GlobalStyles } from './Theme.global';
import { defaultTheme } from 'styled-system';

type Props = {
  children: ReactNode;
  theme: DefaultThemeStyledComponents;
};

const Theme = ({ children, theme }: Props) => {
  return (
    <SCThemeProvider theme={theme}>
      <GlobalStyles />
      {children}
    </SCThemeProvider>
  );
};

export { defaultTheme, Theme };
